<div class="app-card-box tab-container w-100">
  <div class="px-sm py-xsm ts-caption tab-header-box"
       (click)="selectTab(tab, i)"
       [ngClass]="tab.active ? 'selected': ''"
       *ngFor="let tab of tabs;let i = index;">
    {{tab.title}}
  </div>
</div>

<ng-content></ng-content>
